import React, { useState, createContext } from 'react';
import { SettingsContextType } from '../types/settingsContextTypes';

export const SettingsContext = createContext<SettingsContextType>({} as SettingsContextType);

interface ISettingsContextProviderProps extends React.PropsWithChildren {}

export const SettingsContextProvider = (props: ISettingsContextProviderProps) => {
  // Set the initial state of the settings in environment variables
  const [settings, setSettings] = useState({
    debugMode: process.env.REACT_APP_DEBUG_MODE ? process.env.REACT_APP_DEBUG_MODE === 'true' : false,
    showControlsSystemStart: process.env.REACT_APP_SHOW_DEV_ADMIN_CONTROLS_SYSTEMSTART
      ? process.env.REACT_APP_SHOW_DEV_ADMIN_CONTROLS_SYSTEMSTART === 'true'
      : false,
    showControlsMenu: process.env.REACT_APP_SHOW_DEV_ADMIN_CONTROLS_SIDEMENU
      ? process.env.REACT_APP_SHOW_DEV_ADMIN_CONTROLS_SIDEMENU === 'true'
      : false,
    traceLogToConsole: process.env.REACT_APP_LOG_TO_CONSOLE ? process.env.REACT_APP_LOG_TO_CONSOLE === 'true' : false,
  });
  const [traceLog, setTraceLog] = useState<string[]>([]);
  const [uiUpdateDateVersion] = useState('20250403');


  return (
    <SettingsContext.Provider
      value={{
        settings,
        setSettings,
        traceLog,
        setTraceLog,
        uiUpdateDateVersion,
      }}
    >
      {props.children}
    </SettingsContext.Provider>
  );
};
